/**
 * 首页区块 key 的单一事实来源。
 *
 * 契约:必须与后端 page_sections.section_key 一致
 * (种子见 LandingSeedService.seedSections:hero/features/process/board/stats/
 * scenarios/testimonials/docs/news/cta/footer/seo)。
 * 此前管理端前端自造 process-flow/kanban/docs-news 三套命名并存,导致
 * 编辑按钮失灵、发布后状态更新 404、mock 模式下公开区块不渲染——
 * 新增/修改区块 key 时只改这里,消费方一律引用本常量。
 */

/** 区块 key 字面量(消费方用 SECTION_KEY.xxx 替代裸字符串,拼错即编译错误) */
export const SECTION_KEY = {
  hero: 'hero',
  features: 'features',
  process: 'process',
  board: 'board',
  stats: 'stats',
  scenarios: 'scenarios',
  testimonials: 'testimonials',
  docs: 'docs',
  news: 'news',
  cta: 'cta',
  footer: 'footer',
  seo: 'seo',
} as const

export type SectionKey = (typeof SECTION_KEY)[keyof typeof SECTION_KEY]

/** 全部区块 key(process/board/docs/news 为后端命名,无 docs-news 合并块) */
export const SECTION_KEYS: SectionKey[] = Object.values(SECTION_KEY)

/** 区块 key → 管理端编辑页路由(区块配置页"编辑"按钮跳转;docs/news 共用文档资讯页) */
export const SECTION_ROUTE_MAP: Record<string, string> = {
  [SECTION_KEY.hero]: '/admin/landing-page/hero',
  [SECTION_KEY.features]: '/admin/landing-page/features',
  [SECTION_KEY.stats]: '/admin/landing-page/stats',
  [SECTION_KEY.testimonials]: '/admin/landing-page/testimonials',
  [SECTION_KEY.docs]: '/admin/landing-page/docs-news',
  [SECTION_KEY.news]: '/admin/landing-page/docs-news',
  [SECTION_KEY.process]: '/admin/landing-page/process',
  [SECTION_KEY.scenarios]: '/admin/landing-page/scenarios',
  [SECTION_KEY.board]: '/admin/landing-page/kanban',
  [SECTION_KEY.cta]: '/admin/landing-page/cta-footer',
  [SECTION_KEY.footer]: '/admin/landing-page/cta-footer',
  [SECTION_KEY.seo]: '/admin/landing-page/seo',
}

/**
 * 区块 key → 后端发布端点路径(相对 /api/admin/landing)。
 * 注意看板的内容发布端点是 /kanban/publish,而区块 key 是 board。
 */
export const SECTION_PUBLISH_ENDPOINTS: Record<string, string[]> = {
  [SECTION_KEY.hero]: ['/hero/publish'],
  [SECTION_KEY.features]: ['/features/publish'],
  [SECTION_KEY.stats]: ['/stats/publish'],
  [SECTION_KEY.process]: ['/process-steps/publish'],
  [SECTION_KEY.scenarios]: ['/scenarios/publish'],
  [SECTION_KEY.testimonials]: ['/testimonials/publish'],
  [SECTION_KEY.docs]: ['/docs/publish'],
  [SECTION_KEY.news]: ['/news/publish'],
  [SECTION_KEY.board]: ['/kanban/publish'],
  [SECTION_KEY.cta]: ['/cta/publish'],
  [SECTION_KEY.footer]: ['/footer/publish'],
  [SECTION_KEY.seo]: ['/seo/publish'],
}
